import { AxiosResponse } from "axios"
import $api from "../../../axios"
import { ICampaignData } from "../store/types/sponsoredProducts"
import { IFetchSponsoredProductCampaignData } from "../types/campaigns"
import { apiCampaigns } from "../../../constants/targetsApi.constants"

const getCampaignsData = (data: IFetchSponsoredProductCampaignData) => {
  return $api.post<ICampaignData, AxiosResponse<ICampaignData>>(
    `${apiCampaigns}getCampaignsData`,
    data
  )
}

export default {
  getCampaignsData,
}
